<template>
	<el-table
		v-bind:data="exerciseMap"
		:show-header="false"
		row-key="id"
		@row-click="selectRow"
		:expand-row-keys="expand"
		empty-text="No food, water, or bowel movements recorded"
		style="width: 100%">

		<!-- Expandable message history list -->
		<el-table-column type="expand">
			<template slot-scope="scope">
				<EventAnalysis
					:id="scope.row.id"
					:event="scope.row.event">
				</EventAnalysis>
				<!-- <pre>{{ JSON.stringify(scope.row.event, null, 4) }}</pre> -->
			</template>
		</el-table-column>

		<el-table-column width="50">
			<template slot-scope="scope">
				<img v-if="scope.row.id == 'food'" class="lifestyle-icon" src="../image/food.png">
				<img v-else-if="scope.row.id == 'water'" class="lifestyle-icon" src="../image/water.png">
				<img v-else-if="scope.row.id == 'excretion'" class="lifestyle-icon" src="../image/excretion.png">
			</template>
		</el-table-column>

		<el-table-column prop="title" width="300">
			<template slot-scope="scope">
				<div style="line-height:16px">
					<strong style="text-transform:capitalize">{{scope.row.id }}</strong><br>
					<small>{{ formatCount(scope.row.event.length, 'time') }}</small>
				</div>
			</template>
		</el-table-column>

		<el-table-column width="120">
			<template slot-scope="scope">
				<DateRange :row="scope.row"></DateRange>
			</template>
		</el-table-column>

		<el-table-column>
			<template slot-scope="scope">
				<div>
					<!-- graph -->
				</div>
			</template>
		</el-table-column>

	</el-table>
</template>
<script>
import CardTable from '../component/table'
import { mapState, mapGetters, mapActions } from 'vuex'
import EventAnalysis from './analysis/Analysis'

export default {
	name: 'patient-exercise-card-table',
	extends: CardTable,

	props: {
		patient: {
			type: Object,
			required: true
		},
		exercise: {
			type: Array
		}
	},

	methods: {

	},

	computed: {
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		]),
		exerciseMap() {
			return this.typeMap(this.exercise)
		}
	},

	components: {
		EventAnalysis
	}
}
</script>

<style lang="scss" scoped>
.lifestyle-icon {
	float: left;
	margin-left: 6px;
	width: 24px;
	height: 24px;
}
</style>
